import { render, staticRenderFns } from "./InventoryModalOrdersView.vue?vue&type=template&id=1d70dc6e&scoped=true"
import script from "./InventoryModalOrdersView.vue?vue&type=script&setup=true&lang=ts"
export * from "./InventoryModalOrdersView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InventoryModalOrdersView.vue?vue&type=style&index=0&id=1d70dc6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d70dc6e",
  null
  
)

export default component.exports